// NotificationSettings.js - Smart Reminder Frequency
import React, { useState } from 'react';

const options = [
    { label: 'Light (1/day)', value: 'light' },
    { label: 'Balanced (3/day)', value: 'balanced' },
    { label: 'Thorough (6/day)', value: 'thorough' },
];

const NotificationSettings = () => {
    const [level, setLevel] = useState('balanced');
    return (
        <div className="p-4 bg-blue-50 rounded shadow-sm my-2 mx-4">
            <h2 className="font-semibold text-blue-700">Reminder Frequency 🔔</h2>
            <div className="flex space-x-2 mt-2">
                {options.map(o => (
                    <button
                        key={o.value}
                        className={`px-3 py-1 rounded-full ${level === o.value ? 'bg-blue-500 text-white' : 'bg-white border'}`}
                        onClick={() => setLevel(o.value)}
                    >
                        {o.label}
                    </button>
                ))}
            </div>
            <p className="mt-2 text-sm text-gray-600">You’ll receive {options.find(o => o.value === level).label} reminders daily.</p>
        </div>
    );
};

export default NotificationSettings;
